import { fetchWithAuth } from "@/providers/auth-provider";
import { ServiceResponse } from "@/types/services";
import {
  UpdatePokemonSkillsInput,
  UpdatePokemonSkillsOutput,
  WebAppRoutes,
} from "types/web-app";

export const updatePokemonSkills = async (
  accessToken: string,
  input: UpdatePokemonSkillsInput,
) => {
  try {
    const response = await fetchWithAuth(
      "/" + WebAppRoutes.UPDATE_POKEMON_SKILLS,
      accessToken,
      {
        method: "POST",
        body: JSON.stringify(input),
      },
    );

    return (await response.json()) as ServiceResponse<UpdatePokemonSkillsOutput>;
  } catch (error) {
    console.error(error);

    throw error;
  }
};

